import { TrackingDataListItem } from '@api'

import { ActivityStateIndicator } from '@/modules/activity-state/components/activity-state-indicator.tsx'
import { getActivityStateById } from '@/modules/activity-state/utils.ts'

interface ChatterTrackingActivityStatusProps {
  id: number
  activityStates: TrackingDataListItem[]
}

export const ChatterTrackingActivityStatus = ({
  id,
  activityStates,
}: ChatterTrackingActivityStatusProps) => {
  if (activityStates.length === 0) {
    return null
  }

  return (
    <div className="absolute -bottom-1.5 -right-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-card">
      <ActivityStateIndicator
        state={getActivityStateById(activityStates ?? [], id)}
      />
    </div>
  )
}
